import { TFeeLedgerRow } from "@/features/management-ledger/types/management-ledger";

export const isFeeRowEmpty = (row: TFeeLedgerRow) =>
    row.payerCompanyId == null && !row.collectionDate && !row.feeType && !row.feeAmount && !row.feeBasis && !row.remarks;

const normalizeFeeText = (value: string | null | undefined) => value ?? "";

export const isFeeRowDirty = (row: TFeeLedgerRow, server: TFeeLedgerRow) =>
    row.payerCompanyId !== server.payerCompanyId ||
    row.collectionDate !== server.collectionDate ||
    row.feeAmount !== server.feeAmount ||
    normalizeFeeText(row.feeType) !== normalizeFeeText(server.feeType) ||
    normalizeFeeText(row.feeBasis) !== normalizeFeeText(server.feeBasis) ||
    normalizeFeeText(row.remarks) !== normalizeFeeText(server.remarks);
